import WithSeoOverrides from 'src/components/shared/WithSeoOverride'
import { SEO } from './consts'

import AcrossAmericaSection from './AcrossAmericaSection'
import ByTheNumbersSection from './ByTheNumbers'
import TestimonialSection from './TestimonialSection'
import PromiseSection from './PromiseSection'
import FactsSection from './FactsSection'
import ReviewsSection from './ReviewsSection'
import RatingSection from './RatingSection'
import AcdrSection from './AcdrSection'
import HeroSection from './HeroSection'
import { useTrustMarkers } from 'src/common/trust-markers'
import { numberFormat } from 'src/common/utils'

const Facts = ({ trustMarkersCombination, showScheduleACallButton }) => {
  const { getTrustMarkerById } = useTrustMarkers()
  const trustPilot = getTrustMarkerById('truspilot')

  return (
    <main data-testid="facts-page">
      <WithSeoOverrides {...SEO} />

      {/* HeroSection */}

      <HeroSection
        primaryButtonText="Get debt help now"
        secondaryButtonText="Learn More"
        buttonColor="border-red-fdr bg-red-fdr"
        phoneButtonColor="border-blue-accent"
        phoneButtonTextColor="text-blue-accent"
        btnName="Get debt help now"
        phone="800-910-0065"
        showNewTrustpilot
        trustPilotInfo={{
          rating: Number(trustPilot?.rating),
          totalReviews: numberFormat(Number(trustPilot?.totalReview)),
          link: trustPilot?.link,
          color: '#33b083',
        }}
        showScheduleACallButton={showScheduleACallButton}
      />
      {/* Company facts */}
      <FactsSection />

      {/* Promise */}
      <PromiseSection />

      {/* Ratings */}
      <RatingSection trustMarkersCombination={trustMarkersCombination} />

      {/* Testimonial */}
      <TestimonialSection />

      {/* Map */}
      <AcrossAmericaSection />

      {/* By the numbers */}
      <ByTheNumbersSection />

      {/* ACDR members */}
      <AcdrSection />

      {/* Reviews and news */}
      <ReviewsSection />
    </main>
  )
}

export default Facts
